import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class FileValidator {

    name = [
        Validators.required,
        Validators.maxLength(50)
    ];

    // Error messages
    errorMessages = {

        name: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'maxlength',
                message: 'MESSAGES.MAXIMUM_NUMBER',
                options: { maxStr: '50' }
            },
        ]
    }
}